import { extend } from 'vee-validate';
import { required, between } from 'vee-validate/dist/rules';

extend('positive', value => {
  return parseInt(value) > 0
})

extend('multiply', (value, params) => {
  return parseInt(value) % parseInt(params[0]) === 0;
})
extend('required', required);
extend('numeric', value => {
  return !isNaN(value)
});
extend('between', between);
extend('date', value => {
  return Date.parse(value) !== NaN
});

extend('email', value => {
  var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (value.match(validRegex)) {
    // alert("Valid email address!");
    return true;
  } else {
    // alert("Invalid email address!");
    return false;

  }
});